<template>
    <v-container>
        <div v-if="!fetchLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Landed Cost Component</h4>
                    <p class="text-subtitle-1">Modify Landed Cost Component Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <LandedCostComponentForm
                        ref="form"
                        :name.sync="form.name"
                        :ledger-account-id.sync="form.ledger_account_id"
                        :ledger-account.sync="form.ledger_account"
                        />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </v-container>
</template>

<script>
import LandedCostComponentForm from '../../components/purchase/LandedCostComponentForm.vue';
import PAlert from '../../components/common/PAlert.vue';
import landedCostComponent from '../../services/purchase/landedCostComponent';
export default {
    components: {
        LandedCostComponentForm,
        PAlert
    },
    data() {
        return {
            id: null,
            form: {
                name: null,
                ledger_account_id: null
            },
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            fetchLoading: false,
        }
    },
    methods: {
        fetch() {
            this.fetchLoading = true;
            landedCostComponent.find(this.id).then(res => {
                this.form = {
                    ...res.data,
                    ledger_account_id: res.data.ledger_account ? res.data.ledger_account.id : null,
                    ledger_account: res.data.ledger_account
                }
            }).finally(() => {
                this.fetchLoading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, display: true, content: "Are you sure you want to discard changes?", callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        },
        handleSave() {
            this.alert = {...this.alert, display: true, content: "Are you sure you want to save changes?", callback: this.save}
        },
        save() {
            this.loading = true;
            landedCostComponent.update(this.id, this.form).then(res => {
                this.$router.replace({
                    name: "LandedCostComponentDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }

}
</script>

<style>

</style>